// Shared chart chrome for the TracPatch charts: axis tick styling and the
// "Show values" switch.
//
// WHY THIS IS ITS OWN MODULE
// --------------------------
// There are five hand-built d3 charts (steps, cadence, temperature, leg
// position, and the exercise charts), each ~300-460 lines, each of which had
// its own inline `.style('font-size', ...)` calls with slightly different
// numbers. Asking for "bold, one point bigger" across all of them is exactly
// the kind of change that gets applied to four files out of five and then
// drifts further every time someone touches one. The rule lives here.
//
// Same reasoning as src/business/tracpatch_sessions.js on the server: the
// charts keep their own DATA shaping, because the shapes are genuinely
// different, and share only the presentation rule.
import React from 'react'
import { Switch } from 'antd'

// Axis TICK labels (the numbers and dates along each axis). The charts pass
// their existing base size -- which legitimately varies, because a 30-day axis
// packs more labels than a 7-day one -- and get back the bumped value.
//
// "One point bigger" is +1px: these are px values, and at 9-11px a point and a
// pixel are close enough that converting would be false precision.
export const tickFontSize = (basePx) => `${(Number(basePx) || 10) + 1}px`
export const TICK_FONT_WEIGHT = 700

// Apply both to an axis group in one call:  styleAxisTicks(g.call(xAxis), 11)
export function styleAxisTicks(selection, basePx) {
  return selection
    .style('font-size', tickFontSize(basePx))
    .style('font-weight', TICK_FONT_WEIGHT)
}

// Axis TITLES ("Date", "Steps", "Cadence (spm)"). Bold and one point up, same
// treatment as the tick values -- asked for 2026-09-28, having initially been
// left alone on the reasoning that bolding both would leave nothing to separate
// them. In practice the titles sit apart from the plot and read as headings, so
// the earlier worry did not survive seeing it.
//
// Applied to BOTH axes, not just Y: one bold title and one light one on the
// same chart looks like a mistake rather than a hierarchy.
export const AXIS_TITLE_FONT_SIZE = '13px'
export const AXIS_TITLE_FONT_WEIGHT = 700

// The per-chart "Show values" switch. Off by default everywhere: the charts
// are read at a glance for shape and trend, and a number printed at every
// point turns a 30-day series into a wall of digits. Clinicians who want the
// figures can turn them on per chart, and the data-grid view has always had
// the exact numbers.
// Spacing and type size live in `.chartControls .chart-show-values`
// (patient.scss) so the control row can be kept to one line.
export const ShowValuesSwitch = ({ checked, onChange, id }) => (
  <span className="chart-show-values" style={{ display: 'inline-flex', alignItems: 'center' }}>
    <label htmlFor={id} style={{ color: '#555', cursor: 'pointer', marginBottom: 0, whiteSpace: 'nowrap' }}>
      Show values
    </label>
    <Switch id={id} size="small" checked={!!checked} onChange={onChange} />
  </span>
)

export default {
  tickFontSize, TICK_FONT_WEIGHT, styleAxisTicks,
  AXIS_TITLE_FONT_SIZE, AXIS_TITLE_FONT_WEIGHT, ShowValuesSwitch,
}
